/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useMemo } from 'react';
import { STEP1_OPTIONS } from '../options/step1';

interface Step1Props {
  onNext: () => void;
  values: {
    cargo_id: string;
    employee_quantity: string;
    average_participation_bidding: string;
    billing_value: string;
  };
  onChange: (data: Step1Props['values']) => void;
}

const Step1: React.FC<Step1Props> = ({ onNext, values, onChange }) => {
  const canGoNext = useMemo(() => {
    return Boolean(
      values.cargo_id &&
        values.employee_quantity &&
        values.average_participation_bidding &&
        values.billing_value,
    );
  }, [values]);

  return (
    <div className="step-content">
      <div className="step-header">
        <h2 className="step-title m-0">Seja bem-vindo ao ConLicitação!</h2>
        <h5 className="step-subtitle mt-2 mb-0 font-weight-light">
          Seu primeiro passo rumo a novas oportunidades no governo
        </h5>
        <div className="green-line mt-3" />
      </div>

      <div className="step-form mt-5">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group mb-4">
              <label className="step-label">Qual o seu cargo atualmente?</label>
              <select
                className="form-control step-select"
                value={values.cargo_id}
                onChange={(e) => onChange({ ...values, cargo_id: e.target.value })}
              >
                {STEP1_OPTIONS.cargo_id.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group mb-4">
              <label className="step-label">Quantas pessoas atuam com licitação na empresa?</label>
              <select
                className="form-control step-select"
                value={values.employee_quantity}
                onChange={(e) => onChange({ ...values, employee_quantity: e.target.value })}
              >
                {STEP1_OPTIONS.employee_quantity.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group mb-4">
              <label className="step-label">Quantas licitações participa por mês?</label>
              <select
                className="form-control step-select"
                value={values.average_participation_bidding}
                onChange={(e) =>
                  onChange({ ...values, average_participation_bidding: e.target.value })
                }
              >
                {STEP1_OPTIONS.average_participation_bidding.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group mb-4">
              <label className="step-label">Qual o faturamento anual com licitações?</label>
              <select
                className="form-control step-select"
                value={values.billing_value}
                onChange={(e) => onChange({ ...values, billing_value: e.target.value })}
              >
                {STEP1_OPTIONS.average_billing.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="step-actions">
        <button
          type="button"
          className="btn btn-success px-4"
          onClick={onNext}
          disabled={!canGoNext}
        >
          próximo
        </button>
      </div>
    </div>
  );
};

export default Step1;
